const BlogFilters = () => {
    document.addEventListener('alpine:init', () => {
  
      Alpine.data('BlogFilters', () => ({
        open: false,
        loading: true,
        overlayOpen(e) {
          if (e.detail.overlay !== 'BlogFilters') {
            this.closeBlogFilters();
          }
        },
        init() {
          this.getBlogFilters();
        },
        closeBlogFilters() {
          this.open = false;
          this.$dispatch('overlay:close', { overlay: 'BlogFilters' });
        },
        toggleBlogFilters() {
          this.open = !this.open;
  
          if (this.open) {
            this.$dispatch('overlay:open', { overlay: 'BlogFilters' });
          } else {
            this.$dispatch('overlay:close', { overlay: 'BlogFilters' });
          }
        },
        getBlogFilters() {
          this.loading = false;
        },
      }));
    });
  };
  
  export default BlogFilters;
  